<template>
  <div ref="dropdownRef" :tabindex="0" :class="`${classes} tw-cursor-pointer`">
    <span class="three-dots-wrapper tw-cursor-pointer">
      <button
        :disabled="disabled"
        variant="primary"
        :class="[
          `'tw-bg-[#387DFF] tw-text-[${colorText}] !tw-p-0 tw-flex tw-w-fit tw-text-[13px]  tw-leading-[normal] tw-font-medium tw-rounded-[100px] tw-h-[36px] tw-items-center'`,
          active ? '' : 'disable-button',
          buttonClass,
        ]"
      >
        <div class="tw-flex tw-flex-row tw-items-center tw-h-[36px]">
          <div
            :id="idBtn"
            ref="btnRef"
            :class="`tw-py-[8px] tw-pr-[12px] tw-pl-[18px] tw-flex tw-items-center tw-justify-center`"
            :style="{
              minWidth: buttonWidth ? buttonWidth + 'px' : 'max-content',
            }"
            @click.stop="handleClickTitle"
          >
            <div v-if="isLoadingAnimation" class="tw-h-[39px] tw-w-[39px]">
              <!-- eslint-disable vue/no-unused-refs -->
              <LottieAnimation
                ref="anim"
                :animation-data="ProgressAnimation"
                :auto-play="true"
                :loop="true"
              />
            </div>
            <div v-else class="">
              {{ title }}
            </div>
          </div>
          <div
            :id="idPopover"
            class="tw-flex tw-items-center tw-relative"
            @click.stop="openDropdown"
          >
            <div class="tw-w-[1.5px] tw-bg-white tw-h-[36px]" />
            <ArrowButtonIcon
              :class="`tw-ml-[12px] tw-mr-[14px] ${arrowClass}`"
              :color="colorText"
            ></ArrowButtonIcon>
          </div>
        </div>
      </button>
    </span>
    <CustomDropDown
      :id-popover="idPopover"
      :class="!activeDropdown ? 'tw-invisible' : ''"
      :custom-class="customClass"
      :placement="'bottom-end'"
      :timeout="99999999999"
      @on-hover="handleShow"
    >
      <template v-if="activeDropdown" #default>
        <div style="max-width: max-content">
          <slot />
        </div>
      </template>
    </CustomDropDown>
  </div>
</template>

<script lang="ts" setup>
import CustomDropDown from "./customDropDown.vue";
import ArrowButtonIcon from "../svgs/arrowButtonIcon.vue";
import { onBeforeUnmount, onMounted, ref, nextTick } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";

const props = defineProps({
  active: { type: Boolean, required: false, default: true },
  buttonClass: { type: String, required: false, default: "" },
  arrowClass: { type: String, required: false, default: "" },
  title: { type: String, required: false, default: "" },
  colorText: { type: String, default: "#FFF" },
  disabled: { type: Boolean, default: false },
  activeDropdown: { type: Boolean, required: false, default: false },
  idPopover: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  classes: {
    type: String,
    required: false,
    default: "",
  },
  dataType: {
    type: String,
    required: false,
    default: "",
  },
  idBtn: {
    type: String,
    required: false,
    default: "",
  },
  isLoadingAnimation: {
    type: Boolean,
    required: false,
    default: false,
  },
  withBtn: {
    type: String,
    required: false,
    default: "max-content",
  },
});

const dropdownRef = ref<HTMLDivElement | null>(null);
const btnRef = ref<HTMLDivElement | null>(null);
const buttonWidth = ref(0);

const emits = defineEmits(["click-dropdown", "click-title", "leave"]);

const openDropdown = () => {
  EventEmitter.emit(EmitterEvents.OPEN_SCAN_POPOVER, props.dataType);
  setTimeout(() => {
    emits("click-dropdown");
  }, 50);
};

const handleShow = (value) => {
  if (!value) {
    emits("leave");
  }
};

onMounted(async () => {
  window.addEventListener("click", onClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", onClickOutside);
});

const onClickOutside = (event) => {
  emits("leave");
};

const handleClickTitle = async () => {
  await nextTick();
  if (btnRef.value) {
    buttonWidth.value = btnRef.value.offsetWidth;
  }
  emits("click-title");
};
</script>

<style lang="scss" scoped>
.disable-button {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
